import StatsIndex from "@p/stats/TheStatsIndexPage";

export const statsRootPages = {
  path: '/stats',
  name: 'stats_index_route',
  component: StatsIndex
}
